export const sleep = (ms: number) => {
  let timerId: NodeJS.Timeout
  const promise = new Promise((resolve) => {
    timerId = setTimeout(resolve, ms)
  })
  const clear = () => {
    clearTimeout(timerId)
  }
  return { promise, clear }
}
